<template>
  <div class="mobile-login">
    <div class="form-box">
      <!-- <h1 class="title" v-if="registerStep !== 4&&!isRegister&&!forgetPwd">登录</h1>
      <h1 class="title" v-if="forgetPwd">忘记密码</h1>
      <h1 class="title" v-if="isRegister">注册</h1> -->
      <p v-if="registerStep !== 4" class="to-register">
        <!-- <template v-if="!forgetPwd && (!isRegister  || phoneLogin)">
          <span @click="toRegister" class="text-2">立即注册</span>
        </template> -->

        <template v-if="isRegister && !forgetPwd && registerStep!==4">
          <span class="text-1">已有账号，</span>
          <span @click="backLogin" class="text-2">返回登录</span>
        </template>
        <template v-if="forgetPwd">
          <span @click="backLogin" class="text-2">返回登录</span>
        </template>
      </p>

      <div class="login-form">
        <!-- 密码登录-->
        <template v-if="!forgetPwd && !isRegister&& !phoneLogin">
          <div class="input-box">
            <img class="icon" src="../../assets/images/mobile/user.svg" alt="">
            <input v-model="formState.username" placeholder="账号" type="text">
          </div>
          <div class="input-box">
            <img class="icon" src="../../assets/images/password.svg" alt="">
            <input v-model="formState.password" placeholder="密码" type="password">
          </div>
          <button
            @click="showVerify"
            class="button"
            :class="{ 'button-disabled': emptyForm }"
            :disabled="emptyForm"
          >
            <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />登录
          </button>

          <div class="other-opt">
            <span @click="switchPhoneLogin" class="text">手机号登录</span>
            <span @click="switchForgetPwd" class="text">忘记密码</span>
          </div>
        </template>

        <!-- 注册-->
        <template v-if="!forgetPwd && isRegister&& !phoneLogin">
          <div v-show="registerStep === 1">
            <div class="input-box">
              <img class="icon" src="../../assets/images/Phone.svg" alt="">
              <input v-model="registerState.phone" placeholder="手机号" type="text">
            </div>

            <button
              @click="registerGetCode"
              class="button"
              :class="{ 'button-disabled': !registerState.phone }"
              :disabled="registerState.phone === ''"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />发送验证码
            </button>
          </div>

          <div v-show="registerStep === 2">
            <div class="check-code">
              <span class="text">请输入6位数字验证码</span>
              <span v-if=second.value class="text second">{{second.value + 'S'}}</span>
              <span v-else @click="registerGetCode" class="text reFetch">重新发送</span>
            </div>
            <div class="btn-group">
              <template v-for="(item, index) of phoneCode" :key="index">
                <input
                  class="m-input phone-code-input"
                  @input="val => phoneCodeChange(val, item, index)"
                  v-model="item.value"
                  type="text" inputmode="numeric" autocomplete="one-time-code"
                >
              </template>
            </div>
            <button
              @click="phoneRegister"
              style="margin-top: 16px"
              class="button"
              :class="{ 'button-disabled': phoneCode.some(item => item.value === '')}"
              :disabled="phoneCode.some(item => item.value === '')"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />注册
            </button>
            <div class="agree-box" v-if='false'>
              <a-checkbox class="remember-pwd" v-model:checked="registerState.agreement">
                <span class="agree">已阅读并同意浩邈账号<span class="user-agree" @click.self="showRegister">《用户协议》</span><span class="agree">和</span><span class="user-agree" @click.self="showPrivacy">《隐私政策》</span></span>
              </a-checkbox>

              <!-- <div class="agree-input">
                <input type="checkbox" id="cbox1">
              </div>
              <label class="agree-label" for="cbox1">已阅读并同意浩邈账号<span class="text" @click.self="showRegister">《用户协议》</span>和<span class="text" @click.self="showPrivacy">《隐私政策》</span></label> -->
            </div>
          </div>

          <div v-show="registerStep === 3">
            <p class="pwd-tip">您注册的手机号为：{{registerState.phone}}，请设置登录密码，密码长度 6~32 数字或字母组合，区分大小写</p>
            <div class="input-box">
              <img class="icon" src="../../assets/images/password.svg" alt="">
              <input v-model="registerState.newPassword" placeholder="设置密码" type="password">
            </div>

            <div class="input-box">
              <img class="icon" src="../../assets/images/password.svg" alt="">
              <input v-model="registerState.confirmPassword" placeholder="确认密码" type="password">
            </div>

            <button
              @click="registerSetPwd"
              class="button"
              :class="{ 'button-disabled': registerState.newPassword==='' || registerState.confirmPassword==='' }"
              :disabled="registerState.newPassword==='' || registerState.confirmPassword===''"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />提交
            </button>
          </div>

          <div v-show="registerStep === 4" class="reg-finish">
            <div class="icon-box">
              <img class="icon" src="../../assets/images/mobile/smile.svg" alt="">
            </div>
            <p class="reg-finish-tip">您的账号：{{registerState.phone}} 已成功注册！</p>
            <button @click="backLogin" class="button">立即登录</button>
            <button @click="backLogin" class="button button-plain" style="margin-top: 16px">返回首页</button>
          </div>
        </template>

        <!-- 忘记密码-->
        <template v-if="forgetPwd && !isRegister&& !phoneLogin">
          <div v-show="forgetStep === 1">
            <div class="input-box">
              <img class="icon" src="../../assets/images/Phone.svg" alt="">
              <input v-model="forgetState.phone" placeholder="手机号" type="text">
            </div>

            <button
              @click="forgetGetCode"
              class="button"
              :class="{ 'button-disabled': !forgetState.phone }"
              :disabled="forgetState.phone === ''"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />
              发送验证码
            </button>
          </div>

          <div v-show="forgetStep === 2">
            <div class="check-code">
              <span class="text">请输入6位数字验证码</span>
              <span v-if=second.value class="text second">{{second.value + 'S'}}</span>
              <span v-else @click="forgetGetCode" class="text reFetch">重新发送</span>
            </div>
            <div class="btn-group">
              <template v-for="(item, index) of phoneCode" :key="index">
<!--                m-input-error-->
                <input
                  class="m-input phone-code-input"
                  @input="val => phoneCodeChange(val, item, index)"
                  v-model="item.value"
                  type="text" inputmode="numeric" autocomplete="one-time-code"
                >
              </template>
            </div>
            <button
              @click="forgetCheckCaptcha"
              style="margin-top: 16px"
              class="button"
              :class="{ 'button-disabled': phoneCode.some(item => item.value === '') }"
              :disabled="phoneCode.some(item => item.value === '')"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />
              下一步
            </button>
          </div>

          <div v-show="forgetStep === 3">
            <p class="pwd-tip">您手机号为 {{forgetState.phone}} 请设置您的密码：</p>
            <div class="input-box">
              <img class="icon" src="../../assets/images/password.svg" alt="">
<!--              class="input-error"-->
              <input v-model="forgetState.newPassword" placeholder="设置密码" type="password">
            </div>

            <div class="input-box">
              <img class="icon" src="../../assets/images/password.svg" alt="">
              <input v-model="forgetState.confirmPassword" placeholder="确认密码" type="password">
            </div>
            <p class="pwd-tip">密码长度6-32位数字或字符组合，区分大小写</p>
            <button
              @click="forgetEditPwd"
              class="button"
              :class="{ 'button-disabled': forgetState.newPassword==='' || forgetState.confirmPassword==='' }"
              :disabled="forgetState.newPassword==='' || forgetState.confirmPassword===''"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />
              提交
            </button>
          </div>
        </template>

        <!-- 手机号登录-->
        <template v-if="!forgetPwd && !isRegister&& phoneLogin">
          <!-- v-show="phoneLoginStep === 1" -->
          <div >
            <div class="input-box">
              <img class="icon" src="../../assets/images/Phone.svg" alt="">
              <input v-model="phoneLoginState.phone" placeholder="手机号" type="text"  maxLength="11">
            </div>
            <div class="input-box">
              <img class="icon" src="../../assets/images/verify.svg" alt="">
              <input v-model="phoneLoginState.smscode" placeholder="验证码" type="text" inputmode="numeric" autocomplete="one-time-code" maxLength="6">
              <span v-if="second.value" class="reqsmstxt">{{second.value + 's'}}</span>
              <span class="reqsmstxt" :class="{ 'light': smsStatus}" v-else  @click="reqSmsCode" >发送验证码</span>
            </div>

            <!-- <button
              class="button"
              @click="reqSmsCode"
              :class="{ 'button-disabled': !phoneLoginState.phone }"
              :disabled="phoneLoginState.phone === ''"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />
              发送验证码
            </button> -->
            <div class="other-opt">
              <span @click="toRegister" class="text">注册账号</span>
              <span @click="switchAccountLogin" class="text">密码登录</span>
            </div>

            <button
              @click="submitPhoneLogin"
              style="margin-top: 16px"
              class="button"
              :class="{ 'button-disabled': phoneLoginState.smscode === '' }"
              :disabled="phoneLoginState.smscode === ''"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />
              登录
            </button>

            <div class="other-opt">
               <span @click="switchForgetPwd" class="text"></span>
              <span @click="switchForgetPwd" class="text">忘记密码</span>
            </div>
          </div>

          <div v-show="phoneLoginStep === 2">
            <div class="check-code">
              <span class="text">请输入6位数字验证码</span>
              <span v-if=second.value class="text second">{{second.value + 'S'}}</span>
              <span v-else @click="reqSmsCode" class="text reFetch">重新发送</span>
            </div>
            <div class="btn-group">
              <template v-for="(item, index) of phoneCode" :key="index">
                <input
                  class="m-input phone-code-input"
                  @input="val => phoneCodeChange(val, item, index)"
                  v-model="item.value"
                  type="text" inputmode="numeric" autocomplete="one-time-code"
                >
              </template>
            </div>
            <button
              @click="submitPhoneLogin"
              style="margin-top: 16px"
              class="button"
              :class="{ 'button-disabled': phoneCode.some(item => item.value === '') }"
              :disabled="phoneCode.some(item => item.value === '')"
            >
              <LoadingOutlined class="icon-loading" v-show="btnLoading.loading" />
              登录
            </button>

            <div class="other-opt">
              <span @click="switchAccountLogin" class="text">账密登录</span>
              <span @click="switchForgetPwd" class="text">忘记密码</span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 验证码弹窗-->
    <Verify
      @success="success"
      mode="pop"
      captchaType="blockPuzzle"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    />

    <!-- 注册 -->
    <Verify
      v-if="showVerity"
      @success="registerSuccess"
      mode="pop"
      captchaType="newBlockPuzzle"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newVerify"
      :phone = "registerState.phone"
    />

    <!-- 手机登录 phoneLogin -->
    <Verify
      v-if="showPLVerity"
      @success="PLSuccess"
      mode="pop"
      captchaType="newBlockPuzzle"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newPLVerify"
      :phone = "phoneLoginState.phone"
    />

    <!-- 忘记密码 forgotPassword -->
    <Verify
      v-if="showFPVerity"
      @success="FPSuccess"
      mode="pop"
      captchaType="newBlockPuzzle"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newFPVerify"
      :phone = "forgetState.phone"
    />

  </div>
</template>

<script>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { defineComponent, reactive, ref, onBeforeMount, toRaw } from 'vue';
import { captchaInput, loginModule } from '@/utils/mixin';
import Schema from 'async-validator';
import { login } from '@/utils/api';
import { APP_ID, APP_SECRET, PLAT_TYPE, FROM_OS, redirectUrl } from '@/utils/constant';
import { getAgreement, showPrivacy, showRegister } from '@/utils/setup/agreement';
import Verify from '@/components/verifition/Verify';
import moment from 'moment';
import { MD5 } from 'crypto-js';
import store from '@/store';
import { pwdValidate } from '@/utils/setup/pwdValidate';
import eruda from 'eruda';

let formRules = {
  username: [{ required: true, message: '请输入账号' }],
  password: [{ required: true, message: '请输入密码' }],
  code: [{ required: true, message: '请输入验证码' }],
  phone: [
    { required: true, message: '请输入手机号' },
    { pattern: /^1\d{10}$/, message: '手机号为11位有效数字' }
  ]
};

export default {
  name: 'appLogin',
  setup () {
    onBeforeMount(() => {
      window.document.title = '登录';
      getAgreement();
    });
    return { showPrivacy, showRegister };
  },
  data () {
    return {
      smsStatus: false,
      second: { value: 0 },
      showVerity: false,
      showPLVerity: false,
      showFPVerity: false,
      btnLoading: { loading: false },
      forgetPwd: false,
      isRegister: false,
      phoneLogin: true,
      registerStep: 1,
      phoneLoginStep: 1,
      forgetStep: 1,
      phoneLoginState: { phone: '', smscode: ''},
      registerState: { phone: '', agreement: false},
      forgetState: { phone: '', newPassword: '', confirmPassword: '' },
      formState: {
        username: '',
        password: '',
        code: ''
      }
    };
  },
  components: { LoadingOutlined, Verify },
  mixins: [captchaInput, loginModule],
  computed: {
    emptyForm () {
      return this.formState.username === '' || this.formState.password === '';
    },
    currentYear () {
      return moment().format('YYYY');
    }
  },
  watch: {
    'phoneLoginState.phone' () {
      if (this.phoneLoginState.phone.length == 11 && /^1\d{10}$/.test(this.phoneLoginState.phone)) {
        this.smsStatus = true;
      } else {
        this.smsStatus = false;
      }
    }
  },
  // mounted () {
  //   let el = document.createElement('div');
  //   document.body.appendChild(el);
  //   eruda.init({
  //     container: el,
  //     tool: ['console', 'elements', 'Network', 'Resource', 'Info', 'Snippets', 'Sources'],
  //     useShadowDom: true
  //   });
  // },
  methods: {
    /** 倒计时 */
    countDown (second) {
      second.value = 60;
      let countInterval = setInterval(() => {
        if (second.value > 1) {
          second.value--;
        } else {
          clearInterval(countInterval);
          second.value = 0;
        }
      }, 1000);
    },
    resetOptionsData () {
      Object.assign(this.$data, this.$options.data(this));
    },
    /** 切换手机号登录 */
    switchPhoneLogin () {
      this.phoneLogin = true;
      this.isRegister = false;
      this.forgetPwd = false;
      this.clearPhoneCode();
    },
    /** 切换忘记密码 */
    switchForgetPwd () {
      this.phoneLogin = false;
      this.isRegister = false;
      this.forgetPwd = true;
      this.clearPhoneCode();
    },
    switchAccountLogin () {
      this.phoneLogin = false;
      this.isRegister = false;
      this.forgetPwd = false;
      this.clearPhoneCode();
    },
    /** 注册获取验证码 */
    registerGetCode () {
      const { phone } = formRules;
      const validator = new Schema({ phone });
      validator.validate({ phone: this.registerState.phone }, async (errors, fields) => {
        if (errors) {
          this.$message.error(errors[0].message);
          return;
        }
        setTimeout(() => {
          this.showVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newVerify.show();
        }, 100);
      });
    },
    /** 注册验证成功 */
    async registerSuccess (verification) {
      const { captchaVerification } = verification;
      const res = await this.getCaptcha(this.registerState.phone, 4, captchaVerification);
      res && res != '30011' && this.registerStep != 2 && this.registerStep++;
    },
    /** 手机号注册 */
    phoneRegister () {
      this._post({
        url: '/user/registerByPhone',
        params: {
          phone: this.registerState.phone,
          smscode: this.prePhoneCode(),
          platType: PLAT_TYPE,
          fromOs: FROM_OS
        },
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.registerStep++;
        this.clearPhoneCode();
      });
    },
    /** 设置密码（注册成功后） */
    registerSetPwd () {
      let data = {...this.registerState };
      if (data.confirmPassword !== data.newPassword) {
        this.$message.error('两次密码不一致');
        return false;
      }
      if (!pwdValidate(undefined, data.newPassword)) { return; }
      if (!pwdValidate(undefined, data.confirmPassword)) { return; }

      data.newPassword = MD5(data.newPassword).toString();
      data.confirmPassword = MD5(data.confirmPassword).toString();

      this._post({
        url: '/user/updatePwdByPhone',
        params: data,
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.registerStep++;
      });
    },
    /** 获取手机验证码(忘记密码) */
    forgetGetCode () {
      const { phone } = formRules;
      const validator = new Schema({ phone });
      validator.validate({ phone: this.forgetState.phone }, async (errors, fields) => {
        if (errors) {
          // this.$toast(errors[0].message);
          this.$message.error(errors[0].message);
          return;
        }
        setTimeout(() => {
          this.showFPVerity = true;
        }, 0);
        setTimeout(() => {
          this.$refs.newFPVerify.show();
        }, 100);
      });
    },
    FPSuccess (verification) {
      const { captchaVerification } = verification;
      const { phone } = formRules;
      const validator = new Schema({ phone });
      validator.validate({ phone: this.forgetState.phone }, async (errors, fields) => {
        if (errors) {
          // this.$toast(errors[0].message);
          this.$message.error(errors[0].message);
          return;
        }
        const res = await this.getCaptcha(fields.phone, 0, captchaVerification);
        if (res && this.forgetStep != 2) { this.forgetStep++; }
      });
    },
    /** 验证验证码（忘记密码） */
    forgetCheckCaptcha () {
      this._post({
        url: '/userLogin/checkCode',
        params: {
          phone: this.forgetState.phone,
          smscode: this.prePhoneCode(),
          type: 0,
          platType: PLAT_TYPE
        },
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.forgetStep++;
      });
    },
    /** 修改密码（忘记密码） */
    forgetEditPwd () {
      let data = { ...this.forgetState };
      if (data.confirmPassword !== data.newPassword) {
        this.$message.error('两次密码不一致');
        return false;
      }
      if (!pwdValidate(undefined, data.newPassword)) { return; }
      if (!pwdValidate(undefined, data.confirmPassword)) { return; }

      data.newPassword = MD5(data.newPassword).toString();
      data.confirmPassword = MD5(data.confirmPassword).toString();

      this._post({
        url: '/user/forgetPassword',
        params: data,
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        // this.$toast('修改成功');
        this.$message.success('修改成功');
        this.forgetStep = 1;
        this.backLogin();
      });
    },

    /** 获取手机验证码(手机号登录) */
    reqSmsCode () {
      if (!this.smsStatus) {
        return;
      }
      const { phone } = formRules;
      const validator = new Schema({ phone });

      validator.validate(this.phoneLoginState, async (errors, fields) => {
        if (errors) {
          this.$message.error(errors[0].message);
          return;
        }
        setTimeout(() => {
          this.showPLVerity = true;
        }, 0);
        setTimeout(() => {
          this.$refs.newPLVerify.show();
        }, 100);
      });
    },
    /** 手机号登录验证成功 */
    PLSuccess (verification) {
      const { captchaVerification } = verification;
      const { phone } = formRules;
      const validator = new Schema({ phone });
      validator.validate(this.phoneLoginState, async (errors, fields) => {
        if (errors) {
          // this.$toast(errors[0].message);
          this.$message.error(errors[0].message);
          return;
        }
        const res = await this.getCaptcha(fields.phone, 3, captchaVerification);
        if (res && this.phoneLoginStep != 2) {
          this.countDown(this.second);
          // this.phoneLoginStep++;
        }
      });
    },

    /** 手机号登录 */
    submitPhoneLogin () {
      // const smscode = this.prePhoneCode();
      this._post({
        url: '/userLogin/smsLogin',
        params: {
          ...this.phoneLoginState, // phone smscode
          // smscode: smscode,
          appId: APP_ID,
          appSecret: APP_SECRET,
          fromOs: FROM_OS
        },
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.loginSuccessHandle(data);
        this.clearPhoneCode();
      });
    },
    /** 清空六位验证码 */
    clearPhoneCode () {
      this.phoneCode.forEach(item => {
        item.value = '';
      });
    },
    /** 展示验证码弹窗 */
    showVerify () {
      const { username, password } = formRules;
      const validator = new Schema({ username, password });
      validator.validate(this.formState, (errors, fields) => {
        if (errors) {
          // this.$toast(errors[0].message);
          this.$message.error(errors[0].message);
          return;
        }
        this.$refs.verify.show();
      });
    },
    /** 验证码 验证成功 */
    success (verification) {
      const { captchaVerification } = verification;
      this.submitLogin(captchaVerification);
    },
    /** 提交登录（密码登录） */
    submitLogin (verification) {
      let data = { ...this.formState };
      data.password = MD5(data.password).toString();
      this._post({
        url: login.loginByPwd,
        query: {
          captchaVerification: verification,
          grantType: 'password'
        },
        params: {
          ...data,
          appId: APP_ID,
          appSecret: APP_SECRET
        },
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.loginSuccessHandle(data);
      });
    },
    /** 登录成功后的处理 */
    loginSuccessHandle (data) {
      // localStorage.setItem('refreshToken', data.refreshToken);
      // this.setToken(data.accessToken);
      // store.commit('setUserInfo', { uid: data.userId });
      // this.$router.push({ name: 'accountSet' });
      // wx.miniProgram.redirectTo({ url: '/pages/loginInfo/login?type=1&&token=' + data.accessToken + '&&refreshToken=' + data.refreshToken});
      // console.info('跳转目标对象1005', { url: '/pages/loginInfo/login?type=1&&token=' + data.accessToken + '&&refreshToken=' + data.refreshToken});

      // 如果是 'communityApp' (即appType=3) 走新路径/pages/login，否则走老路径/pages/loginInfo/login
      const path = PLAT_TYPE === 'communityApp' ? '/pages/login' : '/pages/loginInfo/login';
      const url = `${path}?type=1&&token=${data.accessToken}&&refreshToken=${data.refreshToken}`;
      wx.miniProgram.redirectTo({ url });
      console.info('跳转目标对象1005', url);
    },
    toRegister () {
      this.isRegister = true;
      this.phoneLogin = false;
    },
    /** 返回登录 */
    backLogin () {
      this.resetOptionsData();
    }
  }
};
</script>
<style lang="scss" scoped>
.light{color: #3A8BE6 !important;}
.reqsmstxt{position:absolute;top:30%;right:6px;color:#abb2bd}
.login-form{
  min-height:73vh;
}
.mobile-login {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .form-box {
    padding: 32px 32px 0;
    height: 100%;
    .title {
      color: rgba(0, 19, 46, 1);
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
    }

    .agree-box {
      margin-top: 32px;
      display: flex;
      .agree-input {
        padding-top: 4px;
        input {
          width: 16px;
          height: 16px;
          border-radius: 4px;
          border: 1px solid rgba(233, 237, 243, 1);
        }
      }
      .agree-label {
        margin-left: 8px;
        color: rgba(43, 54, 74, 1);
        font-family: PingFang SC;
        font-size: 14px;
      }
      .text {
        color: rgba(68, 129, 235, 1);
      }
    }
    .pwd-tip {
      margin-bottom: 32px;
      color: rgba(134, 143, 156, 1);
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 18px;
    }

    .other-opt {
      margin-top: 32px;
      padding: 0 8px;
      display: flex;
      justify-content: space-between;
      .text {
        color: rgba(171, 178, 189, 1);
        font-family: PingFang SC;
        font-size: 14px;
      }
    }
  }

  .footer-box {
    width: 100%;
    color: rgba(255, 255, 255, 1);
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 12px;
    .footer-nav {
      margin-bottom: 16px;
      display: flex;
      justify-content: center;
      .text {
        padding: 0 16px;
      }
      .text+.text {
        border-left: 1px solid #fff;
      }
    }
    .copyright {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
